module.exports = __webpack_public_path__ + "static/media/filmstrip.24fd6a93.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/step-3/filmstrip.png
 ** module id = 354
 ** module chunks = 0
 **/